import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import GaganaPortfolio from './GaganaPortfolio';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GaganaPortfolio />
  </React.StrictMode>
);
